import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            if (u.role !== "admin") {
                toast.error("This account does not have admin access");
                return;
            }
            navigate("/admin");
        } catch (err) {
            toast.error(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-5">
            <div className="w-full max-w-sm bg-white border border-gray-200 rounded-lg p-8 shadow-sm">
                <div className="text-center mb-8">
                    <div className="h-12 w-12 rounded-lg bg-ink mx-auto flex items-center justify-center"><Lock className="h-5 w-5 text-gold" /></div>
                    <h1 className="font-serif text-2xl mt-4">ELVOSH Admin</h1>
                    <p className="text-sm text-gray-500 mt-1">Private staff access only</p>
                </div>
                <form onSubmit={submit} className="space-y-4">
                    <input data-testid="admin-email" type="email" required placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-gray-300 rounded px-3 py-2.5 text-sm outline-none focus:border-gold" />
                    <input data-testid="admin-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-gray-300 rounded px-3 py-2.5 text-sm outline-none focus:border-gold" />
                    <button data-testid="admin-login-submit" disabled={loading} className="w-full bg-ink text-white py-2.5 rounded text-sm font-medium hover:bg-gray-800 transition-colors disabled:opacity-50">{loading ? "Signing in…" : "Sign In"}</button>
                </form>
            </div>
        </div>
    );
}
